import { render, staticRenderFns } from "./IconWhatsapp.vue?vue&type=template&id=24f3c64e"
import script from "./IconWhatsapp.vue?vue&type=script&lang=js"
export * from "./IconWhatsapp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports